export const TestIds = {
  container: 'chat-input-container',
  textarea: 'chat-input-textarea',
  sendButton: 'chat-input-send-button',
  stopButton: 'chat-input-stop-button',
  errorMessage: 'chat-input-error-message',
};
